module.exports = __webpack_public_path__ + "0a9f81e66afee4709b8cfc1a61114494.svg";